export default __webpack_public_path__ + "static/media/banner-simples-d.55af5a62.svg";